var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form-model',{attrs:{"type":"CLAIM","view-action":_vm.viewAction,"delete-action":_vm.deleteAction,"add-action":_vm.addAction,"update-action":_vm.updateAction}})}
var staticRenderFns = []

export { render, staticRenderFns }